import { render, staticRenderFns } from "./ExamSubmitResult.vue?vue&type=template&id=497cab29&scoped=true"
import script from "./ExamSubmitResult.vue?vue&type=script&lang=js"
export * from "./ExamSubmitResult.vue?vue&type=script&lang=js"
import style0 from "./ExamSubmitResult.vue?vue&type=style&index=0&id=497cab29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497cab29",
  null
  
)

export default component.exports